import React, { Component } from 'react';
import { Rect, Group } from 'react-konva';

export class SeparatorComponentCanvas extends Component {
    render() {
        const { geometry, component, isSelected, dimentionsRatio, draggable } = this.props;

        const geometryWidth = geometry.width * dimentionsRatio;
        const geometryHeight = geometry.height * dimentionsRatio;

        // Define minimum size for clickable area
        const minClickableSize = 10;
        const clickableWidth = Math.max(geometryWidth, minClickableSize);
        const clickableHeight = Math.max(geometryHeight, minClickableSize);

        return (
            <Group
                offsetX={geometry.offsetX}
                offsetY={geometry.offsetY}
                draggable={draggable}
                onDragEnd={this.props.onDragEnd}
                onClick={this.props.onComponentClick ? () => this.props.onComponentClick(component.internalId) : null}>

                {/* Invisible clickable area */}
                <Rect
                    x={geometry.drawPositionX - (clickableWidth - geometryWidth) / 2}
                    y={geometry.drawPositionY - (clickableHeight - geometryHeight) / 2}
                    width={clickableWidth}
                    height={clickableHeight}
                    fill="transparent"
                />

                {/* Actual component */}
                <Rect
                    x={geometry.drawPositionX}
                    y={geometry.drawPositionY}
                    width={geometryWidth}
                    height={geometryHeight}
                    strokeWidth={isSelected ? 3 : 1}
                    stroke={isSelected ? "#6699ff" : component.color}
                    fill={component.color}
                />
            </Group>
        );
    }
}
